export default "__VITE_ASSET__DrgT21VT__"